import { render, staticRenderFns } from "./MedicalPractitioners.vue?vue&type=template&id=7d6831ef&scoped=true"
import script from "./MedicalPractitioners.vue?vue&type=script&lang=ts"
export * from "./MedicalPractitioners.vue?vue&type=script&lang=ts"
import style0 from "./MedicalPractitioners.vue?vue&type=style&index=0&id=7d6831ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6831ef",
  null
  
)

export default component.exports